import { render, staticRenderFns } from "./submission.view.vue?vue&type=template&id=8b1bc14a&scoped=true&"
import script from "./submission.view.vue?vue&type=script&lang=ts&"
export * from "./submission.view.vue?vue&type=script&lang=ts&"
import style0 from "./submission.view.vue?vue&type=style&index=0&id=8b1bc14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1bc14a",
  null
  
)

export default component.exports